import React, { useContext } from 'react';
import { Chip, Grid, Tooltip } from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import AltRouteIcon from '@material-ui/icons/CallSplit';
import { I18nContext } from 'translations';

// The distance/polyline chip means different things depending on the company filter (see
// docs/superpowers/plans/2026-08-29-pibox-web-delivery-route-company-polyline.md §5): once a
// per-company sub-route is resolved, this is "Recorrido de tus paquetes" — NOT the total
// route distance, and never a billing figure (that lives in each package's payment info).
function distanceTooltip(route, filteredByCompany, translate) {
  if (!filteredByCompany) return '';
  if (route.company_route_pending) return translate('app.deliveryRoute.calculatingRouteTooltip');
  return translate('app.deliveryRoute.packagesRouteTooltip');
}

const pillStyle = {
  backgroundColor: '#fff',
  border: '1px solid #E0DCE6',
  fontWeight: 600,
  color: '#545454',
};

export default function RouteSummary({ route }) {
  const { translate } = useContext(I18nContext);
  const filteredByCompany = !!route.filtered_by_company_id;
  const progress = route.stop_count ? Math.round((route.completed_stop_count / route.stop_count) * 100) : 0;
  const progressColor = progress >= 100 ? '#93ca00' : '#7825bd';

  return (
    <div data-testid="route-summary">
      <Grid container spacing={1}>
        <Grid item>
          <Chip
            size="small"
            icon={<RoomIcon style={{ color: progressColor }} />}
            label={`${route.completed_stop_count}/${route.stop_count}`}
            style={pillStyle}
          />
        </Grid>
        <Grid item>
          <Chip
            size="small"
            icon={<LocalShippingOutlinedIcon style={{ color: progressColor }} />}
            label={`${route.delivered_package_count}/${route.package_count}`}
            style={pillStyle}
          />
        </Grid>
        <Grid item>
          <Tooltip title={distanceTooltip(route, filteredByCompany, translate)}>
            <Chip
              size="small"
              icon={<AltRouteIcon style={{ color: progressColor }} />}
              label={route.company_route_pending ? translate('app.deliveryRoute.calculatingRoute') : (route.estimated_distance || '-')}
              style={route.company_route_pending ? { ...pillStyle, opacity: 0.6 } : pillStyle}
              data-testid="distance-chip"
            />
          </Tooltip>
        </Grid>
      </Grid>

      <Grid container justify="space-between" alignItems="center" style={{ marginTop: 16 }}>
        <Grid item>
          <span style={{ fontSize: 13, color: '#828080' }}>{translate('app.deliveryRoute.routeProgress')}</span>
        </Grid>
        <Grid item>
          <span style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>{`${progress}%`}</span>
        </Grid>
      </Grid>
      <div style={{ height: 6, borderRadius: 3, backgroundColor: '#EFEBF3', marginTop: 6, overflow: 'hidden' }}>
        <div
          data-testid="route-progress-bar"
          style={{ height: '100%', width: `${progress}%`, backgroundColor: progressColor, borderRadius: 3, transition: 'width 0.3s ease' }}
        />
      </div>
    </div>
  );
}
